import {Component, OnInit, Inject} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ErrorStateMatcher} from '@angular/material/core';
import {MemberBackgroundData} from 'src/app/models/member-background-data';

/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-member-order-date-dialog',
  templateUrl: './member-order-date-dialog.component.html',
  styleUrls: [ './member-order-date-dialog.component.scss' ]
})
export class MemberOrderDateDialogComponent implements OnInit {

  public matcher = new FormErrorStateMatcher();
  public form: FormGroup;
  public isEdit: boolean

  public backgroundLocations: any[] = [];

  constructor (
    private fb: FormBuilder,
    public matDialogRef: MatDialogRef<MemberOrderDateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MemberBackgroundData
  ) {
    this.form = this.createForm(this.data)
  }

  ngOnInit () {
  }

  createForm (data) {
    let form: FormGroup = this.fb.group({
      order_id: new FormControl(data.order_id),
      order_date: new FormControl(data.order_date, [ Validators.required ])
    });
    return form
  }



}

